import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Company } from 'src/app/models/company.model';
import { Role } from 'src/app/models/role.model';
import { Access, User } from 'src/app/models/user.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { RoleService } from 'src/app/services/role/role.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent {
  userDetails: User = new User();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private companyService: CompanysService,
    private roleService: RoleService,
    private toastr: ToastrService
  ) {}
  companies: Company[] = [];
  roles: Role[] = [];
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();

  public accesses: Array<Access> = [
    { Id: 0, Name: 'Active' },
    { Id: 1, Name: 'Locked' },
    { Id: 2, Name: 'Disabled' },
  ];
  selectedStatus: number = -1;

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      loggedInuserRole.role == 'Standard User' ||
      loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    this.roleService.getAllRoleType().subscribe({
      next: (roles) => {
        this.roles = roles;
        if(loggedInuserRole.role == 'Internal User'){
          this.roles = roles.filter((role: Role) => role.Name === "Standard User");
        }
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.route.paramMap.subscribe({
      next: (params) => {
        const UserId = atob(params.get('id')!);
        if (UserId) {
          this.userService.getUser(UserId).subscribe({
            next: (response) => {
              console.log(response);
              this.userDetails = response;

              // When IsLockOut is false & ActionType is "I" then  set Active 
              // When IsLockOut is True & ActionType is "F" then  set Lock
              // When IsLockOut is false & ActionType is "I" then  set Disable

              if (this.userDetails.IsLockedOut === false && this.userDetails.ActionType === 'I') {
                this.selectedStatus = 0 // Active
              } else if (this.userDetails.IsLockedOut === true && this.userDetails.ActionType === 'I') {
                this.selectedStatus = 1 // Lock
              } else if (this.userDetails.IsLockedOut === false && this.userDetails.ActionType === 'F') {
                this.selectedStatus = 2 // Disable
              }
            },
          });
        }
      },
    });

    

    this.companyService.getAllCompanys().subscribe({
      next: (companies) => {
        this.companies = companies;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  // updateRoleName(event: Event) {
  //   const selectedRoleId = (event.target as HTMLSelectElement).value;
  //   const selectedRole = this.roles.find((role) => role.Id === selectedRoleId);

  //   if (selectedRole) {
  //     this.userDetails.RoleName = selectedRole.Name;
  //   }
  // }

  UpdateUser() {
    const matchingRole = this.roles.find(
      (role) => role.Id === this.userDetails.RoleId
    );
    if (matchingRole) {
      this.userDetails.RoleName = matchingRole.Name;
    }
    this.userDetails.Type = '1';
    if (this.userDetails.PhoneNumber == null) {
      this.userDetails.PhoneNumber = '';
    }
    this.userDetails.Password = '';
    this.userService
      .updateUser(this.userDetails.UserId, this.userDetails)
      .subscribe({
        next: (response) => {
          this.toastr.success('User Updated Successfully.', 'Information');
          this.router.navigate(['/user']);
        },
        error: (response) => {
          if (response.length > 0 ) {
            this.toastr.error(response, 'Information');
          } else {
            this.toastr.error('Error While Updating User.', 'Information');
          }
        },
      });
  }

  // deleteUser(UserId: string) {
  //   this.userService.deleteUser(UserId).subscribe({
  //     next: (response) => {
  //       this.toastr.error('User Deleted Successfully.', 'Information');
  //       this.router.navigate(['/user']);
  //     },
  //   });
  // }
  
  Disable(UserId: string) {
    const confirmDelete = confirm(
      'This will disable this user’s account and prevent them from accessing the program. Are you sure you want to proceed?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }
    this.userService.blockUser(UserId).subscribe(
      () => {
        console.log('User blocked successfully');
        window.location.reload();
        // Handle success
      },
      error => {
        console.error('Error blocking user:', error);
        // Handle error
      }
    );
  }
  
  Enable(UserId: string) {
    const confirmDelete = confirm(
      'This will restore access to this user’s account. Are you sure you want to proceed?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }
    if (this.userDetails.IsLockedOut === true && this.userDetails.ActionType === 'I') {
      this.userService.reactivateUser(UserId).subscribe(
        () => {
          console.log('User reactivated successfully');
          window.location.reload();
          // Handle success
        },
        error => {
          console.error('Error reactivating user:', error);
          window.location.reload();
          // Handle error
        }
      );
    } else if (this.userDetails.IsLockedOut === false && this.userDetails.ActionType === 'F'){
          this.userService.unblockUser(UserId).subscribe(
      () => {
        console.log('User reactivated successfully');
        window.location.reload();
        // Handle success
      },
      error => {
        console.error('Error reactivating user:', error);
        window.location.reload();
        // Handle error
      }
    );
    }

  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
